import React, { createContext, useContext } from "react";
import { translations } from "../data/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const lang = "en";
  const setLang = () => {};
  const t = translations[lang];
  const value = { lang, setLang, t, toggle: () => {} };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
